import {
  ZOHO_CUSTOMER_DETAILS_LIST,
  ADD_EDIT_ZOHO_CUSTOMER_DETAILS,
  ENABLE_OR_DISABLE_ZOHO_CUSTOMER,
  ZOHO_CUSTOMER_DETAILS_REPORT_PDF,
  ZOHO_CUSTOMER_DETAILS_REPORT_EXCEL,
} from '../resources/endPoint';
import AxiosWrapper from '../http/AxiosWrapper';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';
import { serviceName } from '../resources/serviceConstants';

const Wrapper = new AxiosWrapper();

export const zohoCustomerDetailsList = () => {
  // API call to fetch zoho customer details list (active only)
  return {
    url: ZOHO_CUSTOMER_DETAILS_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: 'MASTER',
  };
};

export const enableOrDisableZohoCustomer = (data) => {
  // API call to enable/disable zoho customer using toggle-status endpoint
  return {
    url: ENABLE_OR_DISABLE_ZOHO_CUSTOMER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: 'MASTER',
  };
};

export const addEditZohoCustomer = (data) => {
  // API call to add or edit zoho customer
  return {
    url: ADD_EDIT_ZOHO_CUSTOMER_DETAILS,
    method: data.customerId ? 'put' : 'post', // Use customerId for method selection
    payload: data,
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: 'MASTER',
  };
};

const downloadFile = async (path, downloadName, contentType) => {
  try {
    const service = serviceName.MASTER_MS;
    const baseUrl = process.env.REACT_APP_API_URL;
    const servicePortPromise = appendServicePortToURL(service);
    const serviceURLPromise = appendServiceNameToURL(service);

    const [servicePort, serviceURL] = await Promise.all([
      servicePortPromise,
      serviceURLPromise,
    ]);

    const url
      = process.env.NODE_ENV === 'development'
        ? `${baseUrl}:${servicePort}${serviceURL}/api${path}`
        : `${baseUrl}${serviceURL}/api${path}`;

    const authToken = Wrapper.getAuthToken();
    const authorization = localStorage.getItem('userRolesToken');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': contentType,
        token: authToken,
        Authorization: authorization,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = downloadName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error(`Failed to download ${contentType}:`, error);
    throw new Error(`Failed to download ${contentType}: ` + error.message);
  }
};

export const getZohoCustomerDetailsDataPdf = async () => {
  // API call to download zoho customer details report as PDF
  const currentDate = new Date().toISOString()
    .split('T')[0];
  const downloadName = `zoho-client-details-report-${currentDate}.pdf`;

  await downloadFile(ZOHO_CUSTOMER_DETAILS_REPORT_PDF, downloadName, 'application/pdf');
};

export const getZohoCustomerDetailsDataExcel = async () => {
  // API call to download zoho customer details report as Excel
  const currentDate = new Date().toISOString()
    .split('T')[0];
  const downloadName = `zoho-client-details-report-${currentDate}.xlsx`;

  await downloadFile(
    ZOHO_CUSTOMER_DETAILS_REPORT_EXCEL,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};
